import React from 'react'
import Layout from '../../Layout'
import AddColorContainer from '../../../../Components/VehicleContainer/AddColorContainer/AddColorContainer'

const AddColor = () => {
  return (
    <Layout>
        <AddColorContainer/>
    </Layout>
  )
}

export default AddColor